import React from "react";
import "./Testimonial.css";

const TestimonialFooter = () => {
  return (
    <div className="testimonialFooter">
      <p>
        Prizma Academy’s German classes in Bangalore offer the perfect
        opportunity for advanced learners to achieve mastery in the German
        language. With experienced trainers, a tailored curriculum, and an
        interactive learning environment, our classes provide everything you
        need to succeed. Enroll today and take the first step towards mastering
        German at the highest level!
      </p>
    </div>
  );
};

export default TestimonialFooter;
